<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["payment_receipt"] }}
        </p>
      </div>
      <div class="content_title">
        {{ new Date().toLocaleString("default", { month: "short" }) }}
        {{ new Date().getDate() }}, {{ new Date().getFullYear() }}
      </div>
      <div class="fees">
        <table>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["parking_fees"] }}
            </td>
            <td style="text-align: left">
              {{
                "$" + this.$store.getters.REQUESTED_VEHICLE_INFO.parkingCharge
              }}
            </td>
          </tr>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["valet_fees"] }}
            </td>
            <td style="text-align: left">
              {{ "$" + this.$store.getters.REQUESTED_VEHICLE_INFO.valetCharge }}
            </td>
          </tr>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["tip_given"] }}
            </td>
            <td style="text-align: left">${{ this.tipValue || 0 }}</td>
          </tr>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["hst_taxes"] }}
            </td>
            <td style="text-align: left">
              {{ "$" + this.$store.getters.REQUESTED_VEHICLE_INFO.taxCharge }}
            </td>
          </tr>
        </table>
      </div>

      <div class="total">
        <p class="title">{{ this.$store.getters.TRANSLATIONS["total"] }}</p>
        <br />
        <p class="amount">
          ${{
            this.totalAmount
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }}
        </p>
      </div>

      <div class="tip">
        <p class="title">{{ this.$store.getters.TRANSLATIONS["add_tip"] }}</p>
        <button class="button amountButton">{{ tip }}</button>
        <div class="controls">
          <img v-on:click="minus()" :src="minusIcon" />
          <img v-on:click="plus()" :src="plusIcon" />
        </div>
        <!-- <button class="button minus">
          <img v-on:click="minus()" :src="minusIcon" />
        </button>
        <button class="button plus">
          <img v-on:click="plus()" :src="plusIcon" />
        </button>-->
      </div>

      <!-- <div class="rating">
        <p>RATE YOUR EXPERIENCE</p>
        <br />
        <br />
        <div class="star-rating">
          <star-rating
            v-model="rating"
            :show-rating="false"
            :padding="15"
            :inline="true"
          ></star-rating>
        </div>
      </div>-->
    </div>

    <div class="footer" v-if="!loading">
      <button
        v-if="showSelectPaymentButton()"
        v-on:click="submitTip()"
        class="button third"
      >
        {{ this.$store.getters.TRANSLATIONS["select_payment"] }}
      </button>
      <button
        v-if="showDoContinueButton()"
        v-on:click="doContinue()"
        class="button fourth"
      >
        {{ this.$store.getters.TRANSLATIONS["continue"] }}
      </button>
    </div>

    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      if (this.$route.query.auto) {
        // this.done();
      }
      this.calcTotal();
    }
  },
  computed: {
    tip: {
      get: function () {
        return (
          "$ " +
          this.tipValue
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        );
      }
    }
  },
  data() {
    return {
      loading: false,
      tipValue: 2,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      calcTotal: () => {
        this.totalAmount = 0;
        const parkingAmount = parseFloat(
          this.$store.getters.REQUESTED_VEHICLE_INFO.parkingCharge
        );
        const valetCharge = parseFloat(
          this.$store.getters.REQUESTED_VEHICLE_INFO.valetCharge
        );

        const parkingTip = parseFloat(this.tipValue);
        const taxes = parseFloat(
          this.$store.getters.REQUESTED_VEHICLE_INFO.taxCharge
        );
        // console.log(parkingAmount, valetCharge, parkingTip, taxes);

        this.totalAmount += parkingAmount ? parseFloat(parkingAmount) : 0;
        this.totalAmount += valetCharge ? parseFloat(valetCharge) : 0;
        this.totalAmount += parkingTip ? parseFloat(parkingTip) : 0;
        // this.totalAmount += taxes ? parseFloat(taxes) : 0;

        // if (this.$store.getters.LOYALTY_VOUCHER_USED) {
        //   this.totalAmount = 0;
        // }
        this.$store.dispatch("SAVE_TOTAL_AMOUNT", this.totalAmount);
      },
      back: () => {
        this.$router.push("/requestInProgress");
      },
      plus: () => {
        this.tipValue = parseFloat((this.tipValue + 1).toFixed(2));
        this.calcTotal();
      },
      minus: () => {
        const newValue = parseFloat((this.tipValue - 1).toFixed(2));
        if (newValue >= 0) this.tipValue = newValue;
        this.calcTotal();
      },
      plusIcon: require("@/assets/icons8-plus-48.png"),
      minusIcon: require("@/assets/icons8-minus-48.png"),
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      rating: 4,
      totalAmount: 0,
      selectPayment() {
        this.$router.push("/selectPayment?returnTo=parkingReceipt");
      },
      doContinue() {
        this.$router.push("/freeParking");
      },
      showLoyaltyButtons() {
        const parkingAmount = parseFloat(
          this.$store.getters.REQUESTED_VEHICLE_INFO.parkingCharge
        );
        const valetCharge = parseFloat(
          this.$store.getters.REQUESTED_VEHICLE_INFO.valetCharge
        );

        return parkingAmount > 0 || valetCharge > 0;
      },
      showSelectPaymentButton() {
        return this.totalAmount > 0;
      },
      showDoContinueButton() {
        return this.totalAmount == 0;
      },
      submitTip: () => {
        if (this.$store.getters.REQUESTED_VEHICLE_INFO.isHotelOvernight) {
          const text =
            "Unable to pay your parking here.<br> Please head to Valet stand for more details.";
          this.$modal.show("dialog", {
            text,
            buttons: [
              {
                title: "OK",
                handler: () => {
                  this.$modal.hide("dialog");
                }
              }
            ]
          });
        } else {
          this.$store.dispatch("SAVE_LAST_PARKING_TIP", this.tipValue);
          this.$router.push("/selectPayment?returnTo=parkingReceipt");
        }

        // const timeout = setTimeout(() => {
        //   this.loading = true;
        // }, 0);
        // this.$http
        //   .post(
        //     `${process.env.SERVER_URL}/2E5E67F509534E64996C6A806C8FD375`,
        //     {
        //       vehicleId: this.$store.getters.REQUESTED_VEHICLE.id,
        //       tipCharge: this.tipValue
        //     },
        //     {
        //       headers: {
        //         "x-access-token": this.$storage.get("parkendaToken")
        //       }
        //     }
        //   )
        //   .then((response) => {
        //     console.log("Add tip charge response:");
        //     console.log(response);
        //     if (response && response.status === 200) {
        //       this.$store.dispatch("SAVE_LAST_PARKING_TIP", this.tipValue);
        //       this.$router.push("/selectPayment?returnTo=parkingReceipt");
        //     }
        //   })
        //   .catch((error) => {
        //     let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
        //     this.$modal.show("dialog", {
        //       text,
        //       buttons: [
        //         {
        //           title: "OK",
        //           handler: () => {
        //             this.$router.push("/requestInProgress");
        //           }
        //         }
        //       ]
        //     });
        //   })
        //   .finally(() => {
        //     clearTimeout(timeout);
        //     this.loading = false;
        //   });
      }
    };
  },
  components: {
    StarRating
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.wrapper {
  touch-action: none;
}
.header {
  height: 50px;
}
.fees {
  border-radius: 20px;
  display: block;
  background-color: #fbae31;
  padding: 1vh 0px;
  margin: 0 10vw;
}
.fees table {
  width: 100%;
  text-align: center;
  font-size: 5vw;
}
.fees table tr td {
  padding: 0.5vh 5vw;
  width: 50%;
  color: white;
  font-size: 4vw;
}
.fees table tr {
  width: 50%;
}
.fees table tr td:first-child {
  border-right: 1px solid white !important;
}

.total {
  margin: 3vh 17vw 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.total .amount,
.total .title {
  font-size: 5vw;
  color: white;
}

.footer {
  height: 20vh;
}

.second {
  background-color: white;
  color: #fbae31;
}
.third {
  background-color: rgba(114, 174, 255, 1);
  color: white;
}
.fourth {
  background-color: white;
  color: rgba(114, 174, 255, 1);
}

.tip {
  margin: 5vh 17vw 0;
  touch-action: none;
}
.tip .title {
  color: white;
  margin: 1vh 17vw 0;
  font-size: 4vw;
}
.tip button {
  width: 100%;
}
.amountButton {
  background-color: white;
  color: #fbae31;
  width: 80% !important;
  float: left;
}
.controls {
  position: absolute;
  border-radius: 100px;
  margin-left: 42vw;
  margin-top: 3.5vw;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 30vw;
  height: 5.5vh;
  background-color: #dedede;
}
.controls img {
  -webkit-filter: opacity(0.5) drop-shadow(0 0 0 blue);
  filter: opacity(0.5) drop-shadow(0 0 0 blue);
  padding: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/ParkingReceipt.vue